const normalizeGuid = (value) =>
  typeof value === "string" ? value.toLowerCase() : value;

const coerceNonNegativeInt = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return 0;
  return Math.max(0, Math.floor(number));
};

export const buildEquipmentQuantityLookup = (records) => {
  if (!Array.isArray(records)) return {};

  return records.reduce((acc, record) => {
    const id = normalizeGuid(record?.equipmentTypeId);
    if (!id) return acc;
    const quantity = coerceNonNegativeInt(record?.quantity);
    const maintenance = coerceNonNegativeInt(record?.maintenanceQuantity);
    const lost = coerceNonNegativeInt(record?.lostQuantity);
    const available = Math.max(0, quantity - maintenance - lost);
    acc[id] = (acc[id] ?? 0) + available;
    return acc;
  }, {});
};

export const getMaxQuantityForKey = (equipmentKey, equipmentKeyToId, quantityByTypeId) => {
  if (!quantityByTypeId) return null;
  const typeId = equipmentKeyToId?.[equipmentKey];
  if (!typeId) return 0;
  const normalizedId = normalizeGuid(typeId);
  return coerceNonNegativeInt(quantityByTypeId[normalizedId] ?? 0);
};

export const clampItemsToMax = (items, equipmentKeys, equipmentKeyToId, quantityByTypeId) => {
  if (!quantityByTypeId) return items;
  if (!items || typeof items !== "object") return items;
  if (!Array.isArray(equipmentKeys) || equipmentKeys.length === 0) return items;

  let changed = false;
  const next = { ...items };

  equipmentKeys.forEach((key) => {
    const current = coerceNonNegativeInt(items[key] ?? 0);
    const max = getMaxQuantityForKey(key, equipmentKeyToId, quantityByTypeId);
    if (max === null) return;
    const clamped = Math.min(current, max);
    if (clamped !== current) {
      next[key] = clamped;
      changed = true;
    }
  });

  return changed ? next : items;
};
